import * as api from '@/api/reolink/serverApi/recommendations';
import type {  IFetchProps, IFetchResponse } from './IComponent';

export const fetch = async (props: IFetchProps): Promise<IFetchResponse> => {
    const res = await api.getCategoryList({ country: props.country, lang: props.lang, show: 'store', type: 'normal' });
    return {
        ...props,
        /**
         * 仅保留正式分类
         */
        categoryList: res.filter((item) => item.isNormal)
    };
};
